export default {
    es: {
        securityPage: {
            tabs: {
                sessions: 'Sesiones',
                apiKeys: 'Claves API',
            },
        },
        securitySessions: {
            title: 'Sesiones Activas',
            refresh: 'Actualizar',
            columns: {
                userId: 'Usuario',
                companyId: 'Empresa',
                tokenType: 'Tipo',
                createdAt: 'Creado',
                lastActivity: 'Última Actividad',
                ipAddress: 'Dirección IP',
                userAgent: 'User Agent',
                actions: 'Acciones',
            },
            actions: {
                killSession: 'Cerrar sesión',
                killUserSessions: 'Cerrar todas las sesiones del usuario',
            },
            confirmKill: {
                title: '¿Cerrar esta sesión?',
                ip: 'IP',
                agent: 'User Agent',
                cancel: 'Cancelar',
                confirm: 'Cerrar',
            },
            confirmKillUser: {
                title: '¿Cerrar todas las sesiones de {username}?',
                cancel: 'Cancelar',
                confirm: 'Cerrar Todas',
            },
            notifications: {
                errorLoad: 'Error al cargar sesiones',
                errorKill: 'Error al cerrar sesión',
                errorKillUser: 'Error al cerrar sesiones del usuario',
                connectionError: 'Error de conexión',
            },
        },
        securityApiKeys: {
            title: 'Claves API',
            refresh: 'Actualizar',
            allRoutes: 'Todas las rutas',
            columns: {
                name: 'Nombre',
                token: 'Token',
                status: 'Estado',
                allowedRoutes: 'Rutas Permitidas',
                createdAt: 'Creado',
                expiresAt: 'Expira',
                revokedAt: 'Revocado',
                actions: 'Acciones',
            },
            status: {
                active: 'Activa',
                expired: 'Expirada',
                revoked: 'Revocada',
            },
            actions: {
                create: 'Crear Clave API',
                revoke: 'Revocar',
            },
            createDialog: {
                title: 'Crear Clave API',
                name: 'Nombre de la Clave',
                nameRequired: 'El nombre es obligatorio',
                expiresInDays: 'Expira en (días)',
                expiresHint: '1–365 días',
                expiresRange: 'Debe estar entre 1 y 365',
                allowedRoutes: 'Rutas Permitidas',
                allowedRoutesHint: 'Dejar vacío para permitir todas las rutas.',
                routeSearchPlaceholder: 'Buscar rutas...',
                selectedRoutes: 'Rutas seleccionadas',
                noRoutesFound: 'No se encontraron rutas',
                cancel: 'Cancelar',
                create: 'Crear',
            },
            tokenDialog: {
                title: 'Clave API Creada',
                warning: 'Copia este token ahora. No se mostrará de nuevo.',
                copy: 'Copiar al portapapeles',
                copied: 'Token copiado al portapapeles',
                done: 'Listo',
            },
            revokeDialog: {
                title: '¿Revocar esta clave API?',
                name: 'Nombre',
                prefix: 'Prefijo del token',
                cancel: 'Cancelar',
                confirm: 'Revocar',
            },
            notifications: {
                errorLoad: 'Error al cargar claves API',
                errorCreate: 'Error al crear clave API',
                errorRevoke: 'Error al revocar clave API',
                connectionError: 'Error de conexión',
            },
        },
    },
    en: {
        securityPage: {
            tabs: {
                sessions: 'Sessions',
                apiKeys: 'API Keys',
            },
        },
        securitySessions: {
            title: 'Active Sessions',
            refresh: 'Refresh',
            columns: {
                userId: 'User',
                companyId: 'Company',
                tokenType: 'Type',
                createdAt: 'Created',
                lastActivity: 'Last Activity',
                ipAddress: 'IP Address',
                userAgent: 'User Agent',
                actions: 'Actions',
            },
            actions: {
                killSession: 'Kill session',
                killUserSessions: 'Kill all user sessions',
            },
            confirmKill: {
                title: 'Kill this session?',
                ip: 'IP',
                agent: 'User Agent',
                cancel: 'Cancel',
                confirm: 'Kill',
            },
            confirmKillUser: {
                title: 'Kill all sessions for {username}?',
                cancel: 'Cancel',
                confirm: 'Kill All',
            },
            notifications: {
                errorLoad: 'Failed to load sessions',
                errorKill: 'Failed to kill session',
                errorKillUser: 'Failed to kill user sessions',
                connectionError: 'Connection error',
            },
        },
        securityApiKeys: {
            title: 'API Keys',
            refresh: 'Refresh',
            allRoutes: 'All routes',
            columns: {
                name: 'Name',
                token: 'Token',
                status: 'Status',
                allowedRoutes: 'Allowed Routes',
                createdAt: 'Created',
                expiresAt: 'Expires',
                revokedAt: 'Revoked At',
                actions: 'Actions',
            },
            status: {
                active: 'Active',
                expired: 'Expired',
                revoked: 'Revoked',
            },
            actions: {
                create: 'Create API Key',
                revoke: 'Revoke',
            },
            createDialog: {
                title: 'Create API Key',
                name: 'Key Name',
                nameRequired: 'Name is required',
                expiresInDays: 'Expires in (days)',
                expiresHint: '1–365 days',
                expiresRange: 'Must be between 1 and 365',
                allowedRoutes: 'Allowed Routes',
                allowedRoutesHint: 'Leave empty to allow all routes.',
                routeSearchPlaceholder: 'Search routes...',
                selectedRoutes: 'Selected routes',
                noRoutesFound: 'No routes found',
                cancel: 'Cancel',
                create: 'Create',
            },
            tokenDialog: {
                title: 'API Key Created',
                warning: 'Copy this token now. It will not be shown again.',
                copy: 'Copy to clipboard',
                copied: 'Token copied to clipboard',
                done: 'Done',
            },
            revokeDialog: {
                title: 'Revoke this API key?',
                name: 'Name',
                prefix: 'Token prefix',
                cancel: 'Cancel',
                confirm: 'Revoke',
            },
            notifications: {
                errorLoad: 'Failed to load API keys',
                errorCreate: 'Failed to create API key',
                errorRevoke: 'Failed to revoke API key',
                connectionError: 'Connection error',
            },
        },
    },
}